import { motion } from "framer-motion";
import { useRef } from "react";
import { useInView } from "framer-motion";

const WhyChooseUs = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  return (
    <section ref={ref} className="padding bg-gray-100 w-full">
      <div className="text-center mb-8">
        <h2 className="text-4xl font-bold mb-6 text-blue-600">
          Why Choose Us?
        </h2>
        <motion.div
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1, transition: { duration: 1.5 } },
          }}
          className="grid max-sm:text-center grid-cols-1 md:grid-cols-3 gap-6"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white text-center p-6 rounded-lg shadow-md transition-transform duration-300 hover:scale-105"
          >
            <div className="flex items-center justify-center mb-4">
              <div className="text-blue-600 text-3xl">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h3 className="text-xl font-bold ml-2">Qualified Faculty</h3>
            </div>
            <p>
              Learn from industry experts and experienced educators dedicated to
              your success.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white p-6 rounded-lg shadow-md transition-transform duration-300 hover:scale-105"
          >
            <div className="flex items-center justify-center mb-4">
              <div className="text-blue-600 text-3xl">
                <i className="fas fa-laptop"></i>
              </div>
              <h3 className="text-xl font-bold ml-2">
                State-of-the-Art Facilities
              </h3>
            </div>
            <p>
              Access to modern classrooms, labs, and technology to enhance your
              learning experience.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white p-6 rounded-lg shadow-md transition-transform duration-300 hover:scale-105"
          >
            <div className="flex items-center justify-center mb-4">
              <div className="text-blue-600 text-3xl">
                <i className="fas fa-user-graduate"></i>
              </div>
              <h3 className="text-xl font-bold ml-2">Personalized Attention</h3>
            </div>
            <p>
              Small class sizes ensure you receive the attention and support you
              need to excel.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
